import React, { ReactElement } from 'react'

import ModoEnum from 'Enumerations/ModoEnum'

import AgendamentoDocas from './AgendamentoDocas'
import AgendamentoDocasIraniFob from './AgendamentoDocasIraniFob'
import { DocasProvider } from './Context/context'
import { DocasStylesManager } from './styles'

interface IProps {
  modo: number
}

const Docas = ({ modo }: IProps): ReactElement => {
  return (
    <DocasProvider>
      <DocasStylesManager>
        {modo === ModoEnum.Normal && <AgendamentoDocas />}
        {modo === ModoEnum.IraniFob && <AgendamentoDocasIraniFob />}
      </DocasStylesManager>
    </DocasProvider>
  )
}

export default Docas
